import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { getDesignToken, primitive } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

export const StyledBackIcon = Icon.withConfig({
  color: getDesignToken('icon-header-contrast'),
  size: '5',
  ...hiddenAccessibilityPlatformProps,
});

export const WidgetBaseStyles = StyleSheet.create({
  container: {
    backgroundColor: primitive.$white,
    borderRadius: 10,
    padding: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});
